// services/jobOfferService.ts
import axios from "axios";
import { JobOffer, JobOfferToBackend } from "../types/features/JobOffer";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const jobOfferService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<JobOffer>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/job-offers`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des offres", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<JobOffer> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/job-offers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de l'offre", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (si tu veux que tout le monde puisse postuler)
  async getBySlug(slug: string): Promise<JobOffer> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/job-offers/slug/${slug}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de l'offre par slug", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: JobOfferToBackend): Promise<JobOffer> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/job-offers`,
         {
        ...data,
        product_name: data.product_name || 'all',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de l'offre", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<JobOfferToBackend>): Promise<JobOffer> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/job-offers/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'offre", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/job-offers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression de l'offre", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      const promises = ids.map((id) => this.delete(token, id));
      await Promise.all(promises);
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};